import app from './assets/json/metadata';

const IS_PRODUCTION = app.build_env === 'production';
const IS_PRODUCTION_BUILD = process.env.NODE_ENV === 'production';

export const GOOGLE_CLIENT_ID = IS_PRODUCTION
  ? '813194298308-k2l8el2sguh8oftqbmif81g4kbl8v8lf.apps.googleusercontent.com'
  : '813194298308-496nuuvfm4bkdampe0ssviumnuk3jlis.apps.googleusercontent.com';

export const RECAPTCHA_KEY = IS_PRODUCTION
  ? '6LfyNRMaAAAAAJN0l6r3ABDryuIUrXP-MGfm5a1a'
  : '6LfwCuIZAAAAAJBBYGvbklrWEAutQT4zB74_y5Kv';

export const REGEX = {
  alphabeticalName: /^[a-z ]+$/gi,
  alphanumericalName: /^[a-zA-Z 0-9]+$/i,
  username: /^(?!.*\.\.)(?!.*\.$)[^\W][\w.]{2,29}$/i,
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  password: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/i,
  mobile: /^[0-9]{8,10}$/,
  otp: /^\d{6,6}$/i,
  domain: /^[a-zA-Z0-9_-]+$/i,
};

export const GET_APP_URL = IS_PRODUCTION_BUILD
  ? IS_PRODUCTION
    ? 'https://bizapp.co'
    : 'https://dev.bizapp.co'
  : 'http://localhost:8000';

export const GET_GENERAL_V1 = IS_PRODUCTION_BUILD
  ? IS_PRODUCTION
    ? 'https://workspace.bizapp.co'
    : 'https://v1-general.bizapp.co'
  : 'http://localhost:3002';

export const GOOGLE_TM_ID = IS_PRODUCTION ? 'GTM-5LBVVXM' : 'GTM-NTSVG88';
export const FACEBOOK_PIXEL_ID = IS_PRODUCTION
  ? '362866001658256'
  : 'TEST_FB_ID';

export const PRIVACY_POLICY_URL = 'https://bizapp.co/privacy-policy';

export const FLAG_URL =
  'https://purecatamphetamine.github.io/country-flag-icons/3x2';
